import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../../utils/IDS";
import { GET, POST } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import Cookies from "js-cookie";

export const GetAllDataOfInternship = createAsyncThunk(
  "website/internship/all-data-of-internship",
  async ({ id, language }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Internship.all_data}/${id}?language=${language || ""}`,
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "auth",
  initialState: {
    all_data_of_internship: [],
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder

      .addCase(GetAllDataOfInternship.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllDataOfInternship.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_data_of_internship = action.payload || [];
      })
      .addCase(GetAllDataOfInternship.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
